<template>
  <div class="new-menu">

    <div v-if="!small">
      <el-row>
        <el-col :span="3">
          <router-link to="/" class="logo"> <img src="../assets/images/Sporte_Black_Tagline.svg"> </router-link>
        </el-col>

        <el-col :span="18" style="padding: 0 8px;">
          <el-row type="flex" justify="end">
            <el-col
              v-for="link in links"
              :key="link.label"
              v-if="userRole >= link.minRole"
              :span="floor(24/links.length)"
            >

              <router-link :to="link.link" class="link">
                {{ link.label }}
              </router-link>

            </el-col>
          </el-row>
        </el-col>

        <el-col :span="3">

          <div class="profile-list" v-if="user.authenticated">
            <el-select v-model="value" @change="changeRoute(value)" :placeholder="userName" empty-text="Error Loading">
              <el-option
                v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </div>

          <div style="padding: 0 16px" v-else>
            <router-link to="/login" class="link">Login</router-link>
          </div>

        </el-col>
      </el-row>

    </div>
    <div v-else>
      <div class="menu-icon" @click="panelOpen = !panelOpen">
        <div class="close" v-if="panelOpen">✕</div>
        <div class="open" v-else>≡</div>
      </div>
      <div class="menu-panel" :class="{ open: panelOpen }">

        <div v-if="user.authenticated">
          <div
            v-for="link in options"
            :key="link.label"
            class="menu-panel-link"
            @click="panelOpen = false"
          >

            <div @click="changeRoute(link.value)" class="link">
              {{ link.label }}
            </div>

          </div>
        </div>
        <div v-else>
          <div
            class="menu-panel-link"
            @click="panelOpen = false"
          >
            <router-link to="/login" class="link">Login</router-link>
          </div>
        </div>

        <div
          v-for="link in links"
          :key="link.label"
          v-if="userRole >= link.minRole"
          class="menu-panel-link"
          @click="panelOpen = false"
        >

          <router-link :to="link.link" class="link">
            {{ link.label }}
          </router-link>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import auth from '../auth'
export default {
  data () {
    return {
      userRole: -1,
      userName: '',
      user: auth.user,
      small: false,
      resizeEvent: null,
      links: [
        { label: 'Sites', link: '/sites', minRole: 0 },
        { label: 'Scheduler', link: '/scheduler', minRole: 1 },
        { label: 'Reports', link: '/reports', minRole: 1 },
        { label: 'Clubs', link: '/clubs', minRole: 1 },
        { label: 'Users', link: '/admin/users', minRole: 2 },
        { label: 'Clients', link: '/admin/clients', minRole: 3 },
        { label: 'Devices', link: '/admin/devices', minRole: 3 },
        { label: 'Help', link: '/help', minRole: -1 }
      ],
      options: [
        { label: 'Logout', value: 'logout' },
        { label: 'Profile', value: 'profile' },
      ],
      panelOpen: false
    }
  },
  beforeMount () {
    // this.user = auth.user.authenticated
    const profile = JSON.parse(auth.getProfile())

    if (profile && Object.keys(profile).length) {
      this.userRole = profile.role
      this.userName = profile.username

      if (this.userRole === 3) {
        this.options.push({ label: 'Settings', value: 'admin/settings' })
      }
    }
  },
  mounted () {
    this.small = document.body.clientWidth < 768
    this.resizeEvent = window.addEventListener('resize', () => {
      this.small = document.body.clientWidth < 768
    })
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.resizeEvent)
  },
  methods: {
    floor (num) {
      return Math.floor(num)
    },
    changeRoute (route) {
      if (!route) return
      if (route === "logout") {
        this.userRole = -1
        this.userName = 0
        auth.logout(this)
      } else{
        this.$router.push({ path:'/' + route });
      }
    }
  },
  watch: {
    '$route' (to) {
      this.panelOpen = false
    }
  }
}
</script>

<style scoped>
  .new-menu {
    background: white;
  }

  .menu-icon {
    z-index: 3;
    position: absolute;
    top: 24px; left: 24px;
    font-size: 32px;
  }

  .menu-panel {
    position: absolute;
    top: 0; bottom: 0; left: 0; right: 0;
    max-width: 500px;
    width: 100vw;
    z-index: 2;
    background: white;
    box-shadow: 0 0 4px 4px rgba(0, 0, 0, 0.3);
    padding: 48px;
    transform: translateX(-100vw);
    transition: transform 150ms ease-in;
  }

  .menu-panel.open {
    transform: translateX(0);
    transition: transform 400ms ease-out;
  }

  .menu-panel .menu-panel-link .link {
    float: none;
    font-size: 32px;
  }

    .logo {
    margin-top:0.5em;
  }

  .logo img {
    height: 4em;
  }


</style>



// WEBPACK FOOTER //
// Menu.vue?4dce5ea9